export default {"src":"/_next/static/media/no-video.6c494cf3.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};